/*********
 Header Sticky
 **********/

// once user has scrolled 80px, change header styling
window.onscroll = function () {
    // some pages need to be overridden and be black the entire time
    if (document.querySelector("#header").classList.contains("override")) {
        return;
    }
    if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
        document.querySelector("#header").classList.add("active");
    } else {
        document.querySelector("#header").classList.remove("active");
    }
};

/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("#slider").classList.add("active");
    document.querySelector('#sliderContent').classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}

// close nav
function closeNav() {
    document.querySelector('#sliderContent').classList.remove('active');
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");

    // Wait before closing - allows animation to complete
    setTimeout(function () {
        document.querySelector("#slider").close();
    }, 400);
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// window resize event listener to take care of the header mobile breakpoints
// we have to make sure the overlaying header always sits nicely on top of the main content
const themeHeader = document.querySelector('#shopify-section-theme-header');
const header = document.querySelector('#header');

// do the initial adjustment if we load on a smaller breakpoint, unless the header sits in the flow
if (window.innerWidth <= 1050 && !header.classList.contains("inFlow")) {
    themeHeader.style.marginBottom = `-${(header.offsetHeight + 1)}px`;
}

window.addEventListener("resize", function () {
    // make sure this only affects it on the smaller breakpoints
    // reset the bottom margin if need be
    // but only if this isn't an override
    if ((window.innerWidth > 1050 && !header.classList.contains("hpOverride")) || header.classList.contains("inFlow")) {
        themeHeader.style.marginBottom = '0';
        return;
    }
    themeHeader.style.marginBottom = `-${(header.offsetHeight + 1)}px`;
})

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));